import axios from 'axios';
import { header } from './header.encry';

const API_URL = process.env.REACT_APP_PEGASUS_API_URL;


export const listVariables = async (type) => {
  const url = type
    ? `${API_URL}/variables/type/${type}`
    : `${API_URL}/variables`;
  const res = await axios.get(url, header());
  return res.data;
};

export default {
  listVariables,
};

